module.exports = __webpack_public_path__ + "static/battle_04-832e26c8b1621db13286ca11bd8f03dd.jpg";